"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutocompleteInput = void 0;

var _composeReactRefs = _interopRequireDefault(require("@seznam/compose-react-refs"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _useKeyboardListNavigation = require("use-keyboard-list-navigation");

var _ = require("..");

var _helpers = require("../../helpers");

var _svgs = require("../../svgs");

var _utils = require("../../utils");

var _useWidthOf2 = require("../../utils/useWidthOf");

var _Box = require("../Box");

var _Clickable = require("../Clickable");

var _LabeledInput = require("../LabeledInput");

var _VisuallyHidden = require("../VisuallyHidden");

var _AutocompleteInputOption = require("./AutocompleteInputOption");

var _AutocompleteInputOptionLabel = require("./AutocompleteInputOptionLabel");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var reducer = function reducer(state, action) {
  switch (action.type) {
    case "OPEN":
      return _objectSpread(_objectSpread({}, state), {}, {
        open: true
      });

    case "CLOSE":
      return _objectSpread(_objectSpread({}, state), {}, {
        open: false
      });

    case "CLEAR":
      return _objectSpread(_objectSpread({}, state), {}, {
        query: ""
      });

    case "CHANGE":
      return _objectSpread(_objectSpread({}, state), {}, {
        query: action.payload.query,
        open: true
      });

    case "SELECT":
      return _objectSpread(_objectSpread({}, state), {}, {
        query: action.payload.query,
        open: false
      });
  }
};

/** AutocompleteInput */
var AutocompleteInput = function AutocompleteInput(_ref) {
  var _staged$text;

  var _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? "" : _ref$defaultValue,
      id = _ref.id,
      loading = _ref.loading,
      onSubmit = _ref.onSubmit,
      onSelect = _ref.onSelect,
      onChange = _ref.onChange,
      onClear = _ref.onClear,
      onClose = _ref.onClose,
      onKeyDown = _ref.onKeyDown,
      height = _ref.height,
      _ref$renderOption = _ref.renderOption,
      renderOption = _ref$renderOption === void 0 ? function (option) {
    return /*#__PURE__*/_react.default.createElement(_AutocompleteInputOptionLabel.AutocompleteInputOptionLabel, option);
  } : _ref$renderOption,
      options = _ref.options,
      rest = _objectWithoutProperties(_ref, ["defaultValue", "id", "loading", "onSubmit", "onSelect", "onChange", "onClear", "onClose", "onKeyDown", "height", "renderOption", "options"]);

  var inputRef = (0, _react.useRef)(null);
  var containerRef = (0, _react.useRef)(null);

  var _splitBoxProps = (0, _Box.splitBoxProps)(rest),
      _splitBoxProps2 = _slicedToArray(_splitBoxProps, 2),
      boxProps = _splitBoxProps2[0],
      inputProps = _splitBoxProps2[1];

  var _useReducer = (0, _react.useReducer)(reducer, {
    open: false,
    query: defaultValue
  }),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var optionsWithRefs = (0, _react.useMemo)(function () {
    return options.map(function (option) {
      return {
        option: option,
        ref: /*#__PURE__*/(0, _react.createRef)()
      };
    });
  }, [options]);

  var resetUI = function resetUI() {
    setTimeout(function () {
      var _inputRef$current;

      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
      reset();
      dispatch({
        type: "CLOSE"
      });
    }, 100);
  };

  var handleSelect = function handleSelect(option, index) {
    var _inputRef$current2;

    dispatch({
      type: "SELECT",
      payload: {
        query: option.text
      }
    });
    (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.focus();
    onSelect === null || onSelect === void 0 ? void 0 : onSelect(option, index);
  };

  var _useKeyboardListNavig = (0, _useKeyboardListNavigation.useKeyboardListNavigation)({
    ref: containerRef,
    list: options,
    waitForInteractive: true,
    onEnter: function onEnter(_ref2) {
      var option = _ref2.element,
          i = _ref2.index;
      handleSelect(option, i);
      resetUI();
    }
  }),
      index = _useKeyboardListNavig.index,
      reset = _useKeyboardListNavig.reset,
      set = _useKeyboardListNavig.set;

  var isDropdownVisible = state.open && options.length > 0; // Reset keyboard navigation when options change
  // eslint-disable-next-line react-hooks/exhaustive-deps

  (0, _react.useEffect)(reset, [options]); // Reset keyboard navigation when query is empty

  (0, _react.useEffect)(function () {
    if (state.query === "") reset();
  }, [reset, state.query]);

  var _usePosition = (0, _utils.usePosition)({
    position: "bottom",
    offset: 10,
    active: isDropdownVisible
  }),
      anchorRef = _usePosition.anchorRef,
      tooltipRef = _usePosition.tooltipRef;

  var _useWidthOf = (0, _useWidthOf2.useWidthOf)({
    ref: anchorRef
  }),
      width = _useWidthOf.width;

  var handleFocus = function handleFocus() {
    reset();
    dispatch({
      type: "OPEN"
    });
  };

  var handleMouseDown = function handleMouseDown(option, i) {
    return function () {
      handleSelect(option, i);
      resetUI();
    };
  };

  var handleMouseEnter = function handleMouseEnter(i) {
    return function () {
      set({
        cursor: i,
        interactive: true
      });
    };
  };

  var handleChange = function handleChange(event) {
    var value = event.currentTarget.value;
    dispatch({
      type: "CHANGE",
      payload: {
        query: value
      }
    });
    onChange === null || onChange === void 0 ? void 0 : onChange(event);
  };

  var handleClearOrSubmit = function handleClearOrSubmit() {
    var _inputRef$current3;

    if (state.query === "") {
      onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(state.query);
      return;
    }

    dispatch({
      type: "CLEAR"
    });
    (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 ? void 0 : _inputRef$current3.focus();
    onClear === null || onClear === void 0 ? void 0 : onClear();
  }; // Moves focus to different options when keyboard navigating using up/down


  (0, _react.useEffect)(function () {
    var _option$ref, _option$ref$current;

    var option = optionsWithRefs[index];
    option === null || option === void 0 ? void 0 : (_option$ref = option.ref) === null || _option$ref === void 0 ? void 0 : (_option$ref$current = _option$ref.current) === null || _option$ref$current === void 0 ? void 0 : _option$ref$current.focus();
  }, [index, optionsWithRefs]);
  var handleFocusChange = (0, _react.useCallback)(function (focused) {
    if (focused || !isDropdownVisible) return;
    dispatch({
      type: "CLOSE"
    });
    reset();
    onClose === null || onClose === void 0 ? void 0 : onClose();
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [onClose, isDropdownVisible]); // Handle closing the dropdown when clicking outside of the input
  // or when focus leaves the input completely

  var _useContainsFocus = (0, _utils.useContainsFocus)({
    onChange: handleFocusChange
  }),
      containsFocusRef = _useContainsFocus.ref;

  var handleInputKeydown = function handleInputKeydown(event) {
    var _inputRef$current4;

    switch (event.key) {
      // Handle <Enter> when nothing is selected
      case "Enter":
        if (state.query !== "" && index === -1) {
          onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(state.query);
          resetUI();
        }

        return;
      // <Esc> to close dropdown

      case "Escape":
        event.preventDefault();
        event.stopPropagation();
        dispatch({
          type: "CLOSE"
        });
        (_inputRef$current4 = inputRef.current) === null || _inputRef$current4 === void 0 ? void 0 : _inputRef$current4.blur();
        return;

      default:
        break;
    }

    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
  }; // Moves focus back to input when typing


  var handleContainerKeydown = function handleContainerKeydown(event) {
    var _inputRef$current5, _inputRef$current6;

    switch (event.key) {
      case "Alt":
      case "ArrowDown":
      case "ArrowUp":
      case "Control":
      case "Enter":
      case "Meta":
      case "Shift":
      case "Tab":
        // Ignore
        return;

      case "Escape":
        event.preventDefault();
        event.stopPropagation();
        dispatch({
          type: "CLOSE"
        });
        (_inputRef$current5 = inputRef.current) === null || _inputRef$current5 === void 0 ? void 0 : _inputRef$current5.blur();
        reset();
        return;

      default:
        (_inputRef$current6 = inputRef.current) === null || _inputRef$current6 === void 0 ? void 0 : _inputRef$current6.focus();
    }
  }; // Option that is being hovered or keyed into


  var staged = options[index];
  return /*#__PURE__*/_react.default.createElement(_Box.Box, _extends({
    ref: (0, _composeReactRefs.default)(containerRef, containsFocusRef),
    onKeyDown: handleContainerKeydown
  }, boxProps), /*#__PURE__*/_react.default.createElement(_LabeledInput.LabeledInput, _extends({
    ref: (0, _composeReactRefs.default)(inputRef, anchorRef),
    role: "combobox",
    "aria-expanded": isDropdownVisible,
    "aria-autocomplete": "list"
  }, id ? {
    id: id,
    "aria-describedby": "".concat(id, "__assistiveHint")
  } : {}, {
    label: loading ? /*#__PURE__*/_react.default.createElement(_Box.Box, {
      width: 18
    }, /*#__PURE__*/_react.default.createElement(_.Spinner, {
      size: "small"
    })) : state.query ? /*#__PURE__*/_react.default.createElement(_Clickable.Clickable, {
      onClick: handleClearOrSubmit,
      height: "100%",
      display: "flex",
      alignItems: "center",
      "aria-label": "Clear input"
    }, /*#__PURE__*/_react.default.createElement(_svgs.CloseIcon, {
      fill: "black60",
      "aria-hidden": true
    })) : /*#__PURE__*/_react.default.createElement(_svgs.MagnifyingGlassIcon, {
      fill: "black60",
      "aria-hidden": true
    }),
    value: (_staged$text = staged === null || staged === void 0 ? void 0 : staged.text) !== null && _staged$text !== void 0 ? _staged$text : state.query,
    onChange: handleChange,
    onFocus: handleFocus,
    onKeyDown: handleInputKeydown,
    autoComplete: "off",
    height: height
  }, inputProps)), isDropdownVisible && /*#__PURE__*/_react.default.createElement(AutocompleteInputDropdown, {
    ref: tooltipRef,
    role: "listbox",
    width: width
  }, optionsWithRefs.map(function (_ref3, i) {
    var option = _ref3.option,
        ref = _ref3.ref;
    return /*#__PURE__*/_react.default.createElement(_AutocompleteInputOption.AutocompleteInputOption, {
      key: i,
      ref: ref,
      role: "option",
      "aria-selected": i === index,
      "aria-posinset": i + 1,
      "aria-setsize": options.length,
      onMouseDown: handleMouseDown(option, i),
      onMouseEnter: handleMouseEnter(i),
      selected: i === index,
      tabIndex: -1
    }, renderOption(option, i));
  })), /*#__PURE__*/_react.default.createElement(_VisuallyHidden.VisuallyHidden, id ? {
    id: "".concat(id, "__assistiveHint")
  } : {}, "When autocomplete results are available use up and down arrows to review and enter to select. Touch device users, explore by touch or with swipe gestures."), isDropdownVisible && /*#__PURE__*/_react.default.createElement(_VisuallyHidden.VisuallyHidden, {
    role: "status",
    "aria-atomic": "true",
    "aria-live": "polite"
  }, options.length === 1 ? "1 result is available" : "".concat(options.length, " results are available")));
};

exports.AutocompleteInput = AutocompleteInput;
AutocompleteInput.displayName = "AutocompleteInput";
var AutocompleteInputDropdown = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "AutocompleteInput__AutocompleteInputDropdown",
  componentId: "sc-89lyrd-0"
})(["box-shadow:", ";max-height:300px;overflow-y:auto;-webkit-overflow-scrolling:touch;z-index:1;"], _helpers.DROP_SHADOW);
//# sourceMappingURL=AutocompleteInput.js.map